import React from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root');

export const BaseModal = ({ children, visible, className = '', onClose = () => {} }) => {
  return (
    <Modal
      isOpen={visible}
      overlayClassName="absolute inset-0 z-top bg-black bg-opacity-80 flex items-center justify-center flex-col overflow-y-scroll overflow-hidden"
      className={className}
      onRequestClose={onClose}>
      {children}
    </Modal>
  );
};
